import Swiper, { EffectFade } from 'swiper';
Swiper.use([EffectFade])

export default function ImageBankCoverSlider () {
    const ImageBankPage = document.querySelector('.mtt-single-image-bank-page')

    if (! ImageBankPage) {
        return
    }

    const slider = new Slider(ImageBankPage)
    slider.init()
}

class Slider {
    constructor (wrapper) {
        this.wrapper = wrapper
        this.slider = this.wrapper.querySelector('.mtt-image-bank-page-image__wrap')

        this.init = () => {
            this.initSlider()
        }
    }

    initSlider () {
        this.swiper = new Swiper (this.slider, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            watchSlidesVisibility: true,
        });

        this.addEventListeners()
    }

    addEventListeners(){
        const PAGINATION_ITEMS = this.wrapper.querySelectorAll('.mtt-image-bank-page-image__swiper-pagination-item')

        if (PAGINATION_ITEMS.length) {
            for (let i = 0; i < PAGINATION_ITEMS.length; i++) {
                const PAGINATION_ITEM = PAGINATION_ITEMS[i]

                PAGINATION_ITEM.addEventListener('click', () => {
                    this.changeSlide(PAGINATION_ITEM.getAttribute('data-id'))
                })
            }
        }
    }

    changeSlide (slide = 0) {
        if(slide !== 0){
            this.swiper.slideTo(slide)
        } else {
            this.swiper.slideNext()
        }
    }
}
